import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2359_75302)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M24.9896 23.9009C25.9462 22.8453 26.6801 21.6413 27.1914 20.2889C27.7027 18.9365 27.9583 17.5346 27.9583 16.0832C27.9583 14.6318 27.7027 13.2299 27.1914 11.8774C26.6801 10.525 25.9462 9.32102 24.9896 8.26546C26.9688 8.52935 28.6181 9.40348 29.9375 10.8879C31.2569 12.3722 31.9167 14.104 31.9167 16.0832C31.9167 18.0623 31.2569 19.7941 29.9375 21.2785C28.6181 22.7629 26.9688 23.637 24.9896 23.9009ZM35.875 39.8332V33.8957C35.875 32.7082 35.6111 31.5784 35.0833 30.5063C34.5556 29.4343 33.8628 28.4859 33.0052 27.6613C34.6875 28.255 36.2461 29.022 37.681 29.9621C39.1159 30.9022 39.8333 32.2134 39.8333 33.8957V39.8332H35.875ZM39.8333 25.979V22.0207H35.875V18.0623H39.8333V14.104H43.7917V18.0623H47.75V22.0207H43.7917V25.979H39.8333ZM16.0833 23.9998C13.9062 23.9998 12.0425 23.2247 10.4922 21.6743C8.94184 20.124 8.16667 18.2603 8.16667 16.0832C8.16667 13.9061 8.94184 12.0424 10.4922 10.492C12.0425 8.94168 13.9062 8.1665 16.0833 8.1665C18.2604 8.1665 20.1241 8.94168 21.6745 10.492C23.2248 12.0424 24 13.9061 24 16.0832C24 18.2603 23.2248 20.124 21.6745 21.6743C20.1241 23.2247 18.2604 23.9998 16.0833 23.9998ZM0.25 39.8332V34.2915C0.25 33.17 0.538628 32.1392 1.11589 31.1991C1.69314 30.259 2.46007 29.5415 3.41667 29.0467C5.46181 28.0241 7.53993 27.2572 9.65104 26.7459C11.7622 26.2346 13.9062 25.979 16.0833 25.979C18.2604 25.979 20.4045 26.2346 22.5156 26.7459C24.6267 27.2572 26.7049 28.0241 28.75 29.0467C29.7066 29.5415 30.4735 30.259 31.0508 31.1991C31.628 32.1392 31.9167 33.17 31.9167 34.2915V39.8332H0.25Z",
			fill: "url(#paint0_linear_2359_75302)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_2359_75302",
		x1: 61795e-9,
		y1: 40.2499,
		x2: 40.8524,
		y2: .418878,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2359_75302",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 47.5,
			height: 47.5,
			fill: "white",
			transform: "translate(0.25 0.25)"
		})
	})] })]
});
export default SvgExtendedAdd;
